import { useQuery } from '@tanstack/react-query';

export const useStudentActivity = (apiHost, courseId) => {
  return useQuery({
    queryKey: ['activity-overview', courseId],
    queryFn: async () => {
      const response = await fetch(
        `${apiHost}/api/v1/dashboards/courses/${courseId}/activity-overview-widget`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Pragma: 'no-cache',
          },
        }
      );
      if (!response.ok) {
        throw new Error('Failed to fetch student activity');
      }
      return response.json();
    },
    enabled: Boolean(apiHost && courseId),
  });
};
